export default __webpack_public_path__ + "static/ModalImgDigitalMarketting-af596853736fb339836ae6630e522cda.png";